export enum DateFormat {
  default = 'dd MMM yyyy',
  timeWithAbbreviatedTimezone = 'HH:mm z', // `18:19 GMT+0`
  monthDayYearHourMinuteAbbreviatedTimezone = 'MMM dd, yyyy HH:mm z', //  'Sep 24, 2021 09:00 GMT+0'
  monthDayYearAtHourMinuteWithTimezone = "MMM dd, yyyy 'at' HH:mm (z)", //  'Sep 24, 2021 at 09:00 (GMT+0)'
  monthDayYearHourMinute = 'MMM dd, yyyy HH:mm', //  'Sep 24, 2021 09:00'
  monthDayYear = 'MMM dd, yyyy', //  'Sep 24, 2021'
  monthYear = 'MMM yyyy', // 'Dec 2020'
  longMonthDayYear = 'MMMM d, yyyy', // ' December 13, 2022'
  hourMinute = 'HH:mm', //  '09:00'
  fullDateStyle = 'EEEE, dd MMMM yyyy', // 'Saturday, 19 December 2020'
  longDateStyle = 'dd MMMM yyyy', // '19 December 2020'
  shortDateStyle = 'dd/MM/yyyy', // '19/12/2020'
  yearMonthDayHyphen = 'yyyy-MM-dd', // '2023-03-15'
  daySlashMonth = 'dd/MM', // '05/11'
  dayOverMonthAbbr = `dd'\n'MMM`, // '05\nOct'
  timezone = 'z',
  shortMonthDay = 'MMM dd', // Aug 03
}
